<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="车牌号">
          <el-input placeholder="请输入车牌号" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <!-- <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button> -->
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加一日三检记录</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="inspection_three_id" label="序号"></el-table-column>
            <el-table-column prop="car_number" label="车牌号"></el-table-column>
            <el-table-column prop="mo_name" label="所属组织"></el-table-column>
            <el-table-column prop="inspect_time" label="检查时间"></el-table-column>
            <el-table-column prop="inspector_names" label="检查人"></el-table-column>
            <el-table-column prop="sign_img" label="签名" width="100">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.sign_img"
                  style="width: 60px; height: 30px;"
                  :src="scope.row.sign_img"
                  :preview-src-list="[scope.row.sign_img]"
                  fit="contain">
                </el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="inspect_res" label="检查结果">
              <template #default="{ row }">
                {{ { '1': '合格', '2': '不合格' }[row.inspect_res] || row.inspect_res }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template #default="{ row }">
                <span :class="`status-badge status-${row.status}`">
                  {{ getStatusText(row.status) }}
                </span>
              </template>
            </el-table-column>
            
            <el-table-column prop="review_name" label="审核确认人"></el-table-column>
            <el-table-column prop="review_time" label="审核确认时间"></el-table-column>
            <el-table-column prop="rectificat_name" label="整改确认人"></el-table-column>
            <el-table-column prop="rectificat_time" label="整改确定时间"></el-table-column>
            <!-- <el-table-column prop="phase" label="行程状态" width="100">
              <template #default="{ row }">
                <el-tag 
                  :type="getPhaseType(row.phase)"
                  size="small"
                  effect="light"
                >
                  {{ getPhaseText(row.phase) }}
                </el-tag>
              </template>
            </el-table-column> -->
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button @click="auditClick(scope.row)" v-if="scope.row.status == 1" type="text" size="small">审核</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :inspection_three_id="inspection_three_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <AuditDialog 
      :visible.sync="open_audit_dialog" 
      :inspection-three-id="audit_inspection_three_id" 
      v-if="open_audit_dialog" 
      @close="closeAuditDialog" 
      @success="auditSuccess">
    </AuditDialog>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import AfuncApi from '@/api/afunc.js'
  import Inspection_threeApi from '@/api/inspection_three.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Import from './part/import.vue';
  import AuditDialog from './part/AuditDialog.vue';

  export default {
    components: {
      Add,
      Edit,
      Import,
      AuditDialog
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        open_import:false,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },
        selection: [],
        selectedRows: [], 
        open_add:false,
        open_edit:false,
        inspection_three_id:"",
        dialogVisible:false,
        open_audit_dialog:false,
        audit_inspection_three_id:"",
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /* 多选框选择变化 */
      handleSelectionChange(selection) {
        this.selectedRows = selection;
      },

      /* 清空选择 */
      clearSelection() {
        if (this.multipleTable) {
          this.multipleTable.clearSelection();
        }
        this.selectedRows = [];
      },
      closeImport(e) {
        this.open_import = false;
        if (e.type === "success") {
          this.getTableList(); // 导入成功后刷新列表
        }
      },
      importClick() {
        this.open_import = true;
      },
      exportData() {
        // 构建导出参数
        let exportParams = {
          search: this.formInline.search,
        };

        // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
        if (this.selectedRows.length > 0) {
          const selectedIds = this.selectedRows.map(row => row.inspection_three_id);
          exportParams.selected_ids = selectedIds.join(',');
        }

        // 使用页面跳转方式导出，避免blob处理
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let queryString = Object.keys(exportParams)
            .filter(key => exportParams[key] !== '')
            .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
            .join('&');

        window.location.href = baseUrl + '/index.php/shop/plus.inspection_three.Index/export?' + queryString;
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//一日三检记录标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    getStatusText(status) {
      const statusMap = {
        '0': '行驶中',
        '1': '待审核',
        '2': '完成',
        '3': '审核驳回',
      };
      return statusMap[status] || status;
    },
    getPhaseText(phase) {
      const phaseMap = {
        '0': '出发前',
        '1': '行驶中',
        '3': '整改',
      };
      return phaseMap[phase] || phase;
    },
    getPhaseType(phase) {
      const typeMap = {
        '0': 'info',
        '1': 'warning',
        '3': 'danger',
      };
      return typeMap[phase] || 'info';
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Inspection_threeApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.inspection_three_id = row.inspection_three_id;
        this.open_edit = true
      },
      async endClick(row) {
        // 验证参数
        if (!row || !row.inspection_three_id) {
          this.$message.warning('数据异常，无法操作');
          return;
        }
        
        try {
          // 确认对话框
          await this.$confirm('确定要结束行程吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          
          // 显示加载中
          const loadingInstance = this.$loading({
            lock: true,
            text: '操作中...',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          
          try {
            // API 调用
            const response = await AfuncApi.call({
              model: 'inspection_three',
              action: 'end_inspection',
              inspection_three_id: row.inspection_three_id 
            });
            
            // 关闭加载
            loadingInstance.close();
            
            // 处理响应
            if (response && response.code === 1) {
              this.$message.success(response.msg || '操作成功');
              this.getTableList(); // 刷新列表
            } else {
              this.$message.error(response.msg || '操作失败，请稍后重试');
            }
            
          } catch (apiError) {
            loadingInstance.close();
          }
          
        } catch (dialogError) {
            // 用户取消操作
            console.log('用户取消操作：', dialogError);
            // 这里不需要显示错误消息
          }
      },
      /*审核*/
      auditClick(row) {
        this.audit_inspection_three_id = row.inspection_three_id;
        this.open_audit_dialog = true;
      },
      closeAuditDialog() {
        this.open_audit_dialog = false;
        this.audit_inspection_three_id = "";
      },
      auditSuccess() {
        this.open_audit_dialog = false;
        this.audit_inspection_three_id = "";
        this.getTableList();
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Inspection_threeApi.del(
              {
                inspection_three_id: row.inspection_three_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style>
/* 自定义样式 */
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-0 {
  background-color: #fdf6ec;
  color: #e6a23c;
  border: 1px solid #f5dab1;
}

.status-1 {
  background-color: #f4f4f5;
  color: #909399;
  border: 1px solid #d3d4d6;
}

.status-2 {
  background-color: #f0f9eb;
  color: #67c23a;
  border: 1px solid #c2e7b0;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/inspection_three/index/index.vue